import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  Grid,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  withWidth,
  makeStyles,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import { remCalc } from '../../../../common/utilities/style-util';
import { globalStyles } from '../../../../common/utilities/style-constants';

const useStyles = makeStyles((theme) => ({
  menuIcon: {
    color: (customerTheme) => customerTheme?.headerTextColor || '#fff',
  },
  menuItemGrid: {
    position: 'relative',
    cursor: 'pointer',
    padding: remCalc(20, 20),
    '&:hover': {
      backgroundColor: (customerTheme) => customerTheme?.headerLinksHoverBackgroundColor || '#494949',
    },
  },
  menuItemGridSelected: {
    position: 'relative',
    '&:after': {
      content: '""',
      width: '100%',
      position: 'absolute',
      bottom: -13,
      left: 0,
      height: 4,
      backgroundColor: (customerTheme) => customerTheme?.headerTextColor || theme.globalColors.white,
    },
  },
  menuItem: {
    color: (customerTheme) => customerTheme?.headerTextColor || theme.globalColors.white,
    fontSize: remCalc(16),
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  menuItemSelected: {
    borderBottom: (customerTheme) => `4px solid ${customerTheme?.headerTextColor || theme.palette.common.white}`,
  },
  subMenuGrid: {
    zIndex: 10,
    position: 'absolute',
    backgroundColor: theme.globalColors.white,
    padding: remCalc(12, 12),
    boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.2)',
    left: 0,
    top: remCalc(55),
    width: 'auto',
    minWidth: 125,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: remCalc(-12),
      left: remCalc(23),
      marginLeft: -5,
      borderWidth: 6,
      borderStyle: 'solid',
      borderColor: 'transparent transparent #FFF transparent',
    },
  },
  link: {
    ...globalStyles.label1,
  },
  selected: {
    backgroundColor: '#ecf0f1',
  },
  hamburgerIconButton: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
}));

const MenuItems = (props) => {
  const {
    menuItems,
    topLevelPath,
    hoverKey,
    toggleHoverOn,
    toggleHoverOff,
    goToLink,
    width,
    customerTheme,
  } = props;
  const classes = useStyles(customerTheme);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickHandler = (item) => {
    goToLink.bind(this, item.link)();
    handleClose();
  };
  if (width === 'sm' || width === 'xs') {
    return (
      <Grid container>
        <IconButton
          onClick={handleClick}
          className={classes.hamburgerIconButton}
        >
          <MenuIcon
            className={classes.menuIcon}
            fontSize="large"
          />
        </IconButton>
        <Menu
          id="long-menu"
          keepMounted
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: 48 * 4.5,
              width: '20ch',
            },
          }}
        >
          {menuItems.map((item, index) => (
            <MenuItem key={index} onClick={onClickHandler.bind(this, item)} className={(item.key === topLevelPath) ? classes.selected : ''}>
              {item.display}
            </MenuItem>
          ))}
        </Menu>
      </Grid>
    );
  } return (
    <Grid container justify="center">
      {menuItems.map((item, index) => {
        const onClick = !item.subItems ? goToLink.bind(this, item.link) : null;

        return (
          <Grid
            item
            key={index}
            className={classNames(classes.menuItemGrid,
              item.key === topLevelPath && classes.menuItemGridSelected)}
            onMouseEnter={toggleHoverOn.bind(this, item.key)}
            onMouseLeave={toggleHoverOff}
            onClick={onClick}
          >
            <Typography className={classes.menuItem}>
              {item.display}
            </Typography>
            {
              item.subItems && hoverKey === item.key ?
                (
                  <Grid container item className={classes.subMenuGrid} justifyContent="center" alignItems="center" spacing={2}>
                    {
                      item.subItems.map((subItem, index) => (
                        <Grid item xs={12} key={index} alignItems="center" justifyContent="center">
                          <Typography
                            className={classes.link}
                            onClick={goToLink.bind(this, subItem.link)}
                          >
                            {subItem.display}
                          </Typography>
                        </Grid>
                      ))
                    }
                  </Grid>
                ) : null
            }
          </Grid>
        );
      })}
    </Grid>
  );
};

MenuItems.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  topLevelPath: PropTypes.string.isRequired,
  hoverKey: PropTypes.string.isRequired,
  toggleHoverOn: PropTypes.func.isRequired,
  toggleHoverOff: PropTypes.func.isRequired,
  goToLink: PropTypes.func.isRequired,
  width: PropTypes.string.isRequired,
  customerTheme: PropTypes.shape({
    bannerBackgroundImage: PropTypes.string,
    bannerButtonColor: PropTypes.string,
    bannerTextColor: PropTypes.string,
    commsBanner: PropTypes.string,
    ctaLink: PropTypes.string,
    ctaText: PropTypes.string,
    customDomain: PropTypes.string,
    footerText: PropTypes.string,
    headerBackgroundColor: PropTypes.string,
    headerLinksHoverBackgroundColor: PropTypes.string,
    headerTextColor: PropTypes.string,
    logo: PropTypes.string,
    siteTitleText: PropTypes.string,
    welcomeMessage: PropTypes.string,
    welcomeText: PropTypes.string,
  }),
};

export default withWidth()(MenuItems);
